export default __webpack_public_path__ + "static/it-60757c3ac3c1b3955c14451b4d192b05.svg";